module.exports = __webpack_public_path__ + "img/menu.48c94104.svg";